import PropTypes from "prop-types";
import { useState, useEffect, useMemo } from "react";
import { BrmDetailTable } from "brm/tables/BrmTables";
import errorUtils from "utils/error-utils";
import { nodeApi, activityApi } from "services/brm/system-service";
import { createColumnMappedNoEdit } from "brm/tables/services/column/columnFactory";
// Styles
import * as S from "brm/styles/details-table.styles";
import { BrmError, DetailTableType } from "features/brm";

const InTable = ({ elementNameInUrl, selectedElement, tableTitle }) => {
  const columns = useMemo(() => [createColumnMappedNoEdit("name"), createColumnMappedNoEdit("category")], []);

  const [inData, setInData] = useState([]);

  useEffect(() => {
    async function getData() {
      function getElementRequest() {
        switch (elementNameInUrl) {
          case DetailTableType.ACTIVITIES.key: {
            return activityApi.getActivityInExchangeWithHttpInfo(selectedElement.id);
          }
          case DetailTableType.NODES.key: {
            return nodeApi.getNodeInExchangeWithHttpInfo(selectedElement.id);
          }
          default: {
            break;
          }
        }
        throw new BrmError(`Unsupported element type:${elementNameInUrl}`);
      }

      try {
        const res = await getElementRequest();
        if (res?.data) {
          errorUtils.checkErrorStatus(res.response.status, res.response.statusText);
          setInData(res.data);
        }
      } catch (err) {
        console.error("Error while loading in data ", err);
      }
    }
    getData();
  }, [elementNameInUrl, selectedElement]);

  return (
    <S.DetailsContainer id="InTable_detailsPanel">
      <BrmDetailTable
        data={inData}
        columns={columns}
        customProps={{ id: "InTable_detailsTable" }}
        showRowSelect={false}
        tableTitle={tableTitle}
        setSelectedElement={() => {}}
      />
    </S.DetailsContainer>
  );
};

InTable.propTypes = {
  elementNameInUrl: PropTypes.any,
  tableTitle: PropTypes.string,
  selectedElement: PropTypes.shape({
    id: PropTypes.any,
  }),
};

export default InTable;
